// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1ProjectPermissionSchema } from './v1/projectPermissionSchema';
import { v1UnauthorizedErrorSchema } from './v1/unauthorizedErrorSchema';

export const listProjectPermissionsPathParamsSchema = z.object({
  account_id: z.number().int().describe("Account ID"),
  id: z.number().int().describe("User ID"),
});

export const listProjectPermissionsHeaderParamsSchema = z.object({
  Authorization: z.coerce.string().describe("OAuth 2.0 Bearer token"),
});

/**
 * @description Project permissions retrieved successfully
 */
export const listProjectPermissions200Schema = z.array(z.lazy(() => v1ProjectPermissionSchema));

/**
 * @description Unauthorized
 */
export const listProjectPermissions401Schema = z.lazy(() => v1UnauthorizedErrorSchema);

export const listProjectPermissionsQueryResponseSchema = z.lazy(() => listProjectPermissions200Schema);
